import React from 'react';
import { HierarchyLevel } from '../../types';

interface HierarchyNavigatorProps {
  path: string[];
  levels: Record<string, HierarchyLevel>;
  onNavigate: (levelId: string) => void;
}

export const HierarchyNavigator: React.FC<HierarchyNavigatorProps> = ({ path, levels, onNavigate }) => {
  if (!path.length) {
    return null;
  }

  return (
    <div className="levels-nav">
      {path.map((levelId, index) => {
        const level = levels[levelId];
        if (!level) return null;

        return (
          <React.Fragment key={levelId}>
            {index > 0 && <span className="level-separator">/</span>}
            <div
              className={`level-indicator ${path[path.length - 1] === levelId ? 'active' : ''}`}
              onClick={() => onNavigate(levelId)}
            >
              {level.name}
              {index === path.length - 1 && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
